<template>
  <div id="comp_calender">
    <div class="calender_title">
      课表
      <div class="calender_now"
           @click="nowDate('today')">今天</div>
    </div>
    <Calendar v-on:choseDay="clickDay"
              v-on:changeMonth="changeDate"
              :markDateMore="arr"
              v-if="today"></Calendar>
    <div class="calender_week">
      <div>{{ClassDate}}</div>
      <div>周{{Classweek}}</div>
    </div>
    <div class="calender_info">
      <div v-if="classArr.length===0">
        <div class="noclass_img">
          <img src="@/assets/img/emptystate_small.png"
               alt />
        </div>
        <div class="warning">
          您暂无课程，可前往
          <router-link tag="span"
                       :to="{ name: 'CourseList'}"
                       style="cursor: pointer;">选择合适的课程</router-link>
        </div>
      </div>
      <div v-if="classArr.length>0&&loading">
        <div class="classtext"
             v-for="(item,index) in classArr"
             :key="index">
          <div>
            <div>{{item.time}}{{item.subject}}</div>
            <div>所属课程:{{item.classSubject}}</div>
            <div>第{{item.subClass}}次课</div>
            <el-button type="primary"
                       :disabled="item.btnState === 1"
                       @click="golive(item.href,item.btnText,item.belong,item.classType)">{{item.btnText}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Calendar from 'vue-calendar-component'
export default {
  props: {
    calenderSend: Array
  },
  data () {
    return {
      // arr: [{ date: '2020/8/10', className: 'mark1' }, { date: '2020/6/7', className: 'mark1' }],
      Classweek: '',
      ClassDate: '',
      arr: [],
      classInfo: {},
      today: true,
      classArr: [],
      loading: false
    }
  },
  components: {
    Calendar
  },
  methods: {
    golive (e, q, w, type) {
      const arr = e.split('/')
      if (q === '线下面授') {
        return false
      } else {
        if (w === '质心灵动量' && type === 2) {
          this.$router.push({
            name: 'live',
            params: { classId: arr[2], subId: arr[3], action: arr[4] }
          })
        } else if (w === '质心灵动量' && type === 5) {
          this.$router.push({
            name: 'offline-live',
            params: { classId: arr[2], subId: arr[3] }
          })
        } else if (w === '' && type === 5) {
          this.$router.push({
            name: 'offline-live',
            params: { classId: arr[2], subId: arr[3] }
          })
        } else if (w === '质心官网' || w === '') {
          const webarr = e.replace('/', '#')
          window.open(process.env.VUE_APP_ZHIXIN_URL + webarr, '_blank')
        }
      }
    },
    clickDay (data) {
      const arr = data.split('/')
      this.ClassDate = arr[1] + '月' + arr[2] + '日'
      this.getweekday(data)
      this.classArr = this.organize(data)
      this.loading = true
    },
    changeDate (data) {
      // console.log('左右点击切换月份', data) //
    },
    clickToday (data) {
      // console.log('跳到了本月', data) //
    },
    getweekday (date) {
      const weekArray = ['一', '二', '三', '四', '五', '六', '日']
      const day = new Date(date).getDay()
      this.Classweek = weekArray[day]
    },
    nowDate (e) {
      if (e === 'today') {
        this.today = false
        this.$emit('fresh')
      }
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const day = now.getDate()
      const date = year + '-' + month + '-' + day
      this.ClassDate = (now.getMonth() + 1) + '月' + (now.getDate()) + '日'
      this.getweekday(date)
      this.classArr = this.organize(date)
      this.loading = true
    },
    // 整理数据
    organize (date) {
      const classArr = []// eslint-disable-line no-unused-vars
      for (let i = 0; i < this.arr.length; i++) {
        let obj = {}
        if (date === this.arr[i].date) {
          obj.classInfo = this.arr[i]
          obj.time = this.arr[i].time
          obj.classSubject = this.arr[i].classSubject
          obj.subClass = this.arr[i].subClass
          obj.href = this.arr[i].href
          obj.btnText = this.arr[i].btnText
          obj.belong = this.arr[i].belong
          obj.btnState = this.arr[i].btnState
          obj.classType = this.arr[i].classType
          obj.subject = this.arr[i].subinfo
          classArr.push(obj)
          obj = {}
        }
      }
      return classArr
    }
  },
  watch: {
    calenderSend: {
      deep: true,
      handler: function () {
        const now = new Date()
        const year = now.getFullYear()
        const month = now.getMonth() + 1
        const day = now.getDate()
        const date = year + '/' + month + '/' + day // 因为日期格式不同直接写一遍逻辑
        this.arr = this.calenderSend
        this.classArr = this.organize(date)
        this.loading = true
        this.today = true
      }
    }
  },
  mounted () {
    this.nowDate()
  }
}
</script>
<style lang="scss">
#comp_calender {
  .wh_content_all {
    background-color: rgba(88, 120, 182);
    .wh_chose_day {
      background-color: rgba(3, 199, 191);
    }
    .wh_content {
      justify-content: space-around;
    }
  }
  .wh_isToday {
    background-color: rgba(3, 199, 191, 0.2);
    // background-color: rgba(3,199,191,0);
    // background: unset;
  }
  // .mark1{
  //     background-color: rgba(3,199,191);
  // }
  .calender_title {
    height: 38px;
    background: #456399;
    color: white;
    text-align: center;
    line-height: 38px;
    font-size: 20px;
    position: relative;
    .calender_now {
      position: absolute;
      top: 10px;
      right: 13px;
      font-size: 12px;
      background-color: #00c7bf;
      height: 20px;
      line-height: 20px;
      width: 40px;
      border-radius: 3px;
      cursor: pointer;
    }
  }
  .calender_week {
    display: flex;
    color: #333;
    font-weight: 600;
    padding: 20px 15px;
    background: white;
  }
  .calender_info {
    padding-bottom: 12px;
    background: white;
    // border-top: 1px solid #e8eaed;
    border-radius: 0 0 4px 4px;
    .classtext {
      padding: 26px 0px 0px 17px;
      border-top: 1px solid #e8eaed;
      div {
        margin-bottom: 22px;
      }
    }
    .noclass_img {
      text-align: center;
    }
    .warning {
      text-align: center;
      span {
        color: #809bc5;
      }
    }
  }
}
</style>
